import { Stack, Typography } from "@mui/material"
import DOMPurify from "dompurify"
import { FC } from "react"

import styles from "../IncidentOverview.module.scss"
import { create } from "src/helpers/bem"
import { useTranslation } from "src/hooks/translation"
import { PageProps } from "src/types/SharedPageProps"

const bem = create(styles, "IncidentOverview")

export const GetSupportCard: FC<{ page: PageProps }> = ({ page }) => {
  const { messages: translations } = useTranslation()
  const incidentsTranslations =
    translations.pages.account.overview.profile.incidents.cards.getSupport
  return (
    <Stack className={bem("card")} direction={"column"}>
      <div className={bem("card", "header")}>
        <Typography variant="subtitle1">
          {incidentsTranslations.title}
        </Typography>
      </div>
      <Stack
        className={bem("card", "content")}
        direction={"column"}
        justifyContent={"space-between"}
        spacing={3}
      >
        <div
          id={bem("mysupport")}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(page?.contact || ""),
          }}
        />
      </Stack>
    </Stack>
  )
}
